import type { FormControl, Message } from './types';

export function ensureSubmitControl(message: Message): Message {
  if (!message.tool_calls) return message;

  const updatedToolCalls = message.tool_calls.map((toolCall) => {
    if (toolCall.name !== 'human_input') return toolCall;

    // biome-ignore lint/suspicious/noExplicitAny: toolCall.args can be HumanInputArgs or TableFormArgs, needs any for type assertion
    const humanInputArgs = toolCall.args as any;
    const hasSubmit = humanInputArgs.form_controls.some(
      // biome-ignore lint/suspicious/noExplicitAny: form_controls array items need any for type checking
      (control: any) => control.type === 'submit',
    );

    if (hasSubmit) return toolCall;

    const submitControl: FormControl = {
      type: 'submit',
      placeholder: 'Enviar',
      form_name: 'submit',
      required: false,
    };

    return {
      ...toolCall,
      args: {
        ...humanInputArgs,
        form_controls: [...humanInputArgs.form_controls, submitControl],
      },
    };
  });

  return {
    ...message,
    tool_calls: updatedToolCalls,
  };
}
